import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import {
    Button,
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
    Field,
    FieldLabel,
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@campai/lib-web/components/new/ui'

type ColorScheme = 'system' | 'light' | 'dark'
const colorSchemes = ['system', 'light', 'dark'] as const

const updateWindowColorScheme = () => {
    const candidate = Reflect.get(window, 'updateColorScheme')
    if (typeof candidate === 'function') {
        candidate()
    }
}

export const Preferences = observer(() => {
    const { t } = useTranslation()
    const [colorScheme, setColorScheme] = useState(localStorage.colorScheme || 'system')
    const [nextColorScheme, setNextColorScheme] = useState(localStorage.colorScheme || 'system')

    const i18nKey = 'profile.ui-preferences'

    return (
        <Card>
            <CardHeader className="border-b">
                <CardTitle>{t(`${i18nKey}.title`)}</CardTitle>
                <CardDescription>{t(`${i18nKey}.description`)}</CardDescription>
            </CardHeader>
            <CardContent>
                <Field>
                    <FieldLabel htmlFor="user-profile-color-scheme">{t(`${i18nKey}.colorScheme`)}</FieldLabel>
                    <Select value={nextColorScheme} onValueChange={(value) => setNextColorScheme(value)}>
                        <SelectTrigger id="user-profile-color-scheme" className="w-full sm:w-72">
                            <SelectValue>
                                {t(`${i18nKey}.colorSchemeValue.${nextColorScheme as ColorScheme}`)}
                            </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                            <SelectGroup>
                                {colorSchemes.map((value) => (
                                    <SelectItem key={value} value={value}>
                                        {t(`${i18nKey}.colorSchemeValue.${value}`)}
                                    </SelectItem>
                                ))}
                            </SelectGroup>
                        </SelectContent>
                    </Select>
                </Field>
            </CardContent>
            <CardFooter className="justify-end">
                <Button
                    onClick={() => {
                        setColorScheme(nextColorScheme)
                        localStorage.colorScheme = nextColorScheme
                        updateWindowColorScheme()
                    }}
                    disabled={nextColorScheme === colorScheme}
                >
                    {t('actions.saveChanges')}
                </Button>
            </CardFooter>
        </Card>
    )
})
